module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/pc/relation_link_senior_right-4fb65ee277a5efb2904a3d76b8eb95f8.png";